module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "epigraphPage",
    attrs: {
      "id": "epi"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epigraphText"
  }, [_vm._v("And we know that all things work together for good to them that love God, to them who are the called according to his purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraphSource"
  }, [_vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Romans")]), _vm._v(" 8:28")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page05"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-faf5b732","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/substitutebridethe_epi.vue
// module id = 69
// module chunks = 0